import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, Users, TrendingUp, Settings, FileText, LogOut, Zap, BookOpen, BarChart3 } from 'lucide-react';

const adminSections = [
  {
    title: 'Overview',
    items: [
      { id: 'dashboard', label: 'Analytics Dashboard', icon: BarChart3 }
    ]
  },
  {
    title: 'Property Management',
    items: [
      { id: 'properties', label: 'All Properties', icon: Building2 }
    ]
  },
  {
    title: 'Operations',
    items: [
      { id: 'operations', label: 'Operations & Actions', icon: Zap },
      { id: 'ledger', label: 'Reconciliation Ledger', icon: BookOpen }
    ]
  },
  {
    title: 'User Management',
    items: [
      { id: 'investors', label: 'Investors', icon: Users },
      { id: 'brokers', label: 'Brokers', icon: TrendingUp }
    ]
  },
  {
    title: 'Transaction Management',
    items: [
      { id: 'transactions', label: 'All Transactions', icon: FileText }
    ]
  },
  {
    title: 'System',
    items: [
      { id: 'settings', label: 'Settings', icon: Settings }
    ]
  }
];

export default function AdminSidebar({ activeTab, setActiveTab, setSelectedUnitId, setSelectedProjectId, onLogout }) {
  return (
    <aside className="fixed top-0 left-0 h-full w-64 bg-black border-r border-white/10 z-40">
      <div className="p-6 border-b border-white/10">
        <h1 className="text-lg font-light text-white">Admin Portal</h1>
        <p className="text-xs text-gray-600 mt-1">AltSlice Management</p>
      </div>

      <nav className="p-4 flex-1 overflow-y-auto h-[calc(100vh-200px)]">
        {adminSections.map((section) => (
          <div key={section.title} className="mb-6">
            <p className="text-xs text-gray-600 uppercase tracking-widest mb-3 px-2">{section.title}</p>
            <div className="space-y-1">
              {section.items.map((item) => {
                const Icon = item.icon;
                const isActive = activeTab === item.id;
                
                return (
                  <button
                    key={item.id}
                    onClick={() => {
                      setActiveTab(item.id);
                      // Clear unit/project selection when switching tabs to prevent navigation lock
                      if (setSelectedUnitId) setSelectedUnitId(null);
                      if (setSelectedProjectId) setSelectedProjectId(null);
                    }}
                    className={`w-full flex items-center gap-3 px-4 py-3 transition-all ${
                      isActive ? 'bg-white/5 border-l-2 border-l-[#4ADE80] text-white' :
                      'text-gray-500 hover:text-white hover:bg-white/5 border-l-2 border-l-transparent'
                    }`}
                  >
                    <Icon className="w-4 h-4" />
                    <span className="text-sm">{item.label}</span>
                    {item.badge && (
                      <span className="ml-auto text-[10px] px-1.5 py-0.5 bg-purple-500/20 text-purple-400 rounded">
                        {item.badge}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </nav>

      <div className="p-4 border-t border-white/10">
        <button onClick={onLogout} className="w-full flex items-center gap-3 px-4 py-3 text-gray-500 hover:text-white transition-colors">
          <LogOut className="w-4 h-4" />
          <span className="text-sm">Logout</span>
        </button>
      </div>
    </aside>
  );
}
